import {
  REQUEST_SONG_FOR_ORDER,
  RECEIVE_SONG_FOR_ORDER,

  
  REQUEST_ORDERS_FROM_LOCAL,
  RECEIVE_ORDERS_FROM_LOCAL,

  // REQUEST_SONG_ORDER,
  
  REQUEST_ORDER,
  // REQUEST_ORDER_PENDING,
  REQUEST_ORDER_FULLFILLED,
  // REQUEST_ORDER_REJECTED
} from '../actions/OrderActions';

const PropsInitialState = {
  items: []
};

function posts(
  state,
  action
) {
  switch (action.type) {
    case REQUEST_SONG_FOR_ORDER: {
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    }
    case RECEIVE_SONG_FOR_ORDER: {
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: [...state.items, action.song],
        lastUpdated: action.receivedAt
      });
    }
    case REQUEST_ORDERS_FROM_LOCAL: {
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    }
    case RECEIVE_ORDERS_FROM_LOCAL: {
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.items,
        lastUpdated: action.receivedAt
      });
    }

    case REQUEST_ORDER: {
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        state: false,
        lastUpdated: action.receivedAt
      });
    }
    case REQUEST_ORDER_FULLFILLED: {
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        state: true,
        lastUpdated: action.receivedAt
      });
    }
    default: {
      return state;
    }
  }
}

function OrderReducer(state = PropsInitialState, action) {
  switch (action.type) {
    case REQUEST_SONG_FOR_ORDER:
    case RECEIVE_SONG_FOR_ORDER:
    case REQUEST_ORDERS_FROM_LOCAL:
    case RECEIVE_ORDERS_FROM_LOCAL:
    case REQUEST_ORDER:
    case REQUEST_ORDER_FULLFILLED: {
      return Object.assign({}, state, posts(state, action));
    }
    default: {
      return state;
    }
  }
}

export {
  OrderReducer
};


// WEBPACK FOOTER //
// ./src/reducers/OrdersReducer.js